export function InterceptorFunction(customAxiosInstance, token, url) {
    customAxiosInstance.interceptors.request.use(
        async (config) => {
            config.baseURL = url;
            config.responseType = "json";
                config.headers = {
                    Authorization: token,
                    Accept: "application/json",
                };
           
            return config;
        },
        (error) => {
            Promise.reject(error);
        }
    );
}

export default { InterceptorFunction };
